import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DesgloseGenero } from '../../../features/analisis/components/tarjeta-analisis-kpi/tarjeta-analisis-kpi.component';

/**
 * Tarjeta KPI de reportes: título con icono, métrica principal, detalle y exportación CSV.
 */
@Component({
  selector: 'app-tarjeta-metrica-reporte',
  templateUrl: './tarjeta-metrica-reporte.component.html',
  styleUrls: ['./tarjeta-metrica-reporte.component.scss'],
  standalone: false
})
export class TarjetaMetricaReporteComponent {
  @Input() id = '';
  @Input() titulo = '';
  @Input() icono = 'analytics-outline';
  @Input() colorIconoCustom = 'var(--ion-color-primary)';
  @Input() valor = '';
  @Input() detalle = '';
  @Input() infoText = '';
  @Input() cargando = false;
  @Input() puedeExportar = false;
  @Input() exportandoCsv = false;
  @Input() desgloses: DesgloseGenero[] = [];

  @Output() exportarCsv = new EventEmitter<void>();

  onExportarCsv(): void {
    if (!this.exportandoCsv && !this.cargando) {
      this.exportarCsv.emit();
    }
  }
}
